import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/icones/iconsmind/style.css';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { ACOES } from '../util/Enums';

const AcessoRapido = (props) => {
    return (

        <div className={'col-lg-12 col-md-12'}>
            <div className='row' >
                {props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 6).permissoes.find(x => parseInt(x) === ACOES.INSERIR) && <div className='col-lg-1 custom-col mb-3'>
                    <Link to={{ pathname: '/atendimento/beneficiario/cadastro' }} style={{ textDecoration: 'none' }}>
                        <div className='dashboard-small-card card b-radius-10'>
                            <a class="a-acesso-rapido" data-flag="atendimento" href="/dashboard">
                                <div class="text-center card-body flex-vertical card-acesso">
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <i class="icon-Mens" style={{ fontSize: '40px' }}></i>
                                    </div>
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <p class="card-text font-weight-semibold mb-0">Paciente</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </Link>
                </div>}
                {props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 6).permissoes.find(x => parseInt(x) === ACOES.INSERIR) && <div className='col-lg-1 custom-col mb-3'>
                    <Link to={{ pathname: '/atendimento/sala-espera/consulta' }} style={{ textDecoration: 'none' }}>
                        <div className='dashboard-small-card card b-radius-10'>
                            <a class="a-acesso-rapido" data-flag="atendimento" href="/dashboard">
                                <div class="text-center card-body flex-vertical card-acesso">
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <i class="icon-Clinic" style={{ fontSize: '40px' }}></i>
                                    </div>
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <p class="card-text font-weight-semibold mb-0">Sala de Espera</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </Link>
                </div>}
                {props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 6).permissoes.find(x => parseInt(x) === ACOES.INSERIR) && <div className='col-lg-1 custom-col mb-3'>
                    <Link to={{ pathname: '/atendimento/agenda/consulta' }} style={{ textDecoration: 'none' }}>
                        <div className='dashboard-small-card card b-radius-10'>
                            <a class="a-acesso-rapido" data-flag="atendimento" href="/dashboard">
                                <div class="text-center card-body flex-vertical card-acesso">
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <i class="icon-Calendar-3" style={{ fontSize: '40px' }}></i>
                                    </div>
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <p class="card-text font-weight-semibold mb-0">Agenda</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </Link>
                </div>}
                {props.permissoes.length > 0 && props.permissoes.find(x => x.modulo_id === 9).permissoes.find(x => parseInt(x) === ACOES.INSERIR) && <div className='col-lg-1 custom-col mb-3'>
                    <Link to={{ pathname: '/atendimento/prontuario/cadastro' }} style={{ textDecoration: 'none' }}>
                        <div className='dashboard-small-card card b-radius-10'>
                            <a class="a-acesso-rapido" data-flag="atendimento" href="/dashboard">
                                <div class="text-center card-body flex-vertical card-acesso">
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <i class="icon-File-ClipboardFileText" style={{ fontSize: '40px' }}></i>
                                    </div>
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <p class="card-text font-weight-semibold mb-0">Novo Prontuário</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </Link>
                </div>}
                <div className='col-lg-1 custom-col mb-3'>
                    <Link to={{ pathname: '/atendimento/painel' }} style={{ textDecoration: 'none' }} onClick={() => {
                        window.location.href = '/atendimento/painel'
                    }}>
                        <div className='dashboard-small-card card b-radius-10'>
                            <a class="a-acesso-rapido" data-flag="atendimento" href="/dashboard">
                                <div class="text-center card-body flex-vertical card-acesso">
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <i class="icon-Navigation-RightWindow" style={{ fontSize: '40px' }}></i>
                                    </div>
                                    <div className='content-center' style={{ flex: 1, justifyContent: 'center' }}>
                                        <p class="card-text font-weight-semibold mb-0">Painel</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </Link>
                </div>
            </div>
        </div>)
}
export { AcessoRapido }